import React, { useEffect, useRef } from 'react';
import { closeFavourites, openFavourites } from './actions';

import { AmbienteContext } from 'context/Ambiente';
import { AnyAction } from '@reduxjs/toolkit';
import { IconsEnum } from 'components/Icons';
import { LIVE_FAVOURITES } from '../../types';
import { LiveFavouriteItem } from 'features/live/liveInternalLayout/liveFavouriteAvvenimentoSlice';
import { LiveNavAccordion } from '../liveNavAccordion/LiveNavAccordion';
import LiveNavAccordionScommessa from '../liveNavAccordionScommessa/LiveNavAccordionScommessa';
import { Spinner } from 'components/spinner';
import styles from './LiveNavFavouriteMenuItem.module.scss';
import { useAppDispatch } from 'lib/centralStore';
import { useFavourites } from '../../hooks';
import { useGetLabelByKey } from 'hooks/useLingUI';

export const LiveNavFavouriteMenuItem = () => {
  const dispatch = useAppDispatch();
  const sidebarMyLives = useGetLabelByKey('sidebar-my-lives');

  const { counter, favourites, allLoading, isLoading, isExpanded, loadedEvents, isAuthenticated } = useFavourites();

  const refExpandedStatus = useRef(isExpanded);
  useEffect(() => {
    if (refExpandedStatus.current !== isExpanded) {
      refExpandedStatus.current = isExpanded;
      const actionToggler = isExpanded ? openFavourites : closeFavourites;
      dispatch(actionToggler({ entryId: LIVE_FAVOURITES }) as unknown as AnyAction);
    }
  }, [dispatch, isExpanded]);

  const renderAvvenimento = (item: LiveFavouriteItem): JSX.Element => {
    const { slugAvvenimento, keyAvvenimento, infoTipoScommessaKey } = item;
    if (allLoading.includes(item.slugAvvenimento)) return <Spinner className={styles.loading} key={slugAvvenimento} />;

    let key = keyAvvenimento;
    if (item && keyAvvenimento && !!infoTipoScommessaKey.filter((key) => key)?.length) {
      key = `${keyAvvenimento}-${infoTipoScommessaKey![0]}`;
    }

    return (
      <AmbienteContext.Provider
        value={{ pathScommessa: ['liveNav', 'favourites', slugAvvenimento], ambiente: 'sport' }}
      >
        <LiveNavAccordionScommessa key={`${slugAvvenimento}_favorite`} identifier={key} />
      </AmbienteContext.Provider>
    );
  };

  const renderContent = (): JSX.Element => {
    if (isLoading) return <Spinner className={styles.loading} />;
    return (
      <React.Fragment key={counter}>
        {favourites
          .filter((item) => loadedEvents.includes(item.slugAvvenimento))
          .map((item) => renderAvvenimento(item))}
      </React.Fragment>
    );
  };

  if (isAuthenticated) {
    return (
      <LiveNavAccordion
        counter={counter}
        entryId={LIVE_FAVOURITES}
        description={sidebarMyLives!}
        iconFavorite={IconsEnum.FULL_PIN}
      >
        {isExpanded && renderContent()}
      </LiveNavAccordion>
    );
  }

  return null;
};
